module.exports = {
  host: "localhost",
  port: 9120,
  apiHost: {
    server       : "http://127.0.0.1/api",
    client       : "/api",
    proxyHeaders : ["SSL", "Ssl-Offload", "X-Forwarded-Proto", "Host", "X-Real-Ip", "X-Forwarded-For"],
  },
  cspUri: null,
  datadog: {
    applicationId: 'e376ad3d-b786-4f34-90ae-a7b3913e01d5',
    clientToken: 'pub2fe3d2b80b8321271c9f0ab982f7c2a1',
    site: 'datadoghq.eu',
    service:'filmforman',
    env:'production',
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingOrigins: [/https:\/\/.*\.crossroads\.se/]
  },
  googleAnalytics: {
    sv_SE: {
      currencyCode: "SEK",
      accounts: ["UA-86419561-4", "UA-5572085-34"]
    }
  },
  isProduction: true
};
